export AI from './AI';
export Cat from './Cat';
export Keyboard from './Keyboard';
export Location from './Location';
export Push from './Push';
export Reminder from './Reminder';
export Speech from './Speech';



// WEBPACK FOOTER //
// ./src/js/Services/index.js